<template>
  <div class="container">
    <div class="swipper">
      <el-carousel height="500px" :interval="3000" arrow="always" trigger="click">
        <el-carousel-item v-for="(item,index) in tuList" :key="index">
          <img class="swipper-img" :src="item.img" alt="banner" @click="toDetail(item)" />
          <div class="desc">
            <p>{{item.title}}</p>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="nes-wrapper">
      <div class="nes-header">
        <div v-for="(item,index) in newsList" :key="item.id" @mouseover="setIndex(index)"
          :class="showIndex===index?'header-item-active':''" class="header-item" @click="toList(item.id)">
          {{item.name}}
        </div>
        <div class="nes-add" @click="toList(newList[0].id)">更多></div>
      </div>
      <div v-for="(i,index) in newsList" :key="index" v-show="showIndex===index">
        <div class="news-item-line" style="display: flex;justify-content: center;flex-wrap: wrap">
          <span @click="toDetail(i.content[0])"
            style="color: #2574c2;font-weight: bold;font-size: 19px;">{{i.content[0].title}}</span>
          <div @click="toDetail(i.content[0])" title="点击查看详情" class="new_sss" v-html="i.content[0].text"
            style="width:95%;height: 51px;margin:0;font-size: 13px;overflow: hidden;line-height:1.4em;"></div>
        </div>
        <div v-for="(m,n) in i.content.slice(0,8)" :key="n" v-if="n>0" class="news-item-line">
          <span @click="toDetail(m)">
            <strong style="font-size: 10px">·</strong>
            {{m.title}}</span>
          <span
            style="flex-shrink: 0">{{m.check_time.substring(m.check_time.indexOf('-')+1,m.check_time.length)}}</span>
        </div>
      </div>
      <div class="img" v-if="szfNewsList.length" @click="toSzf()">
        <img width="100%" height="73px" src="../assets/img/zhengfu-link.jpg" />
      </div>
    </div>
  </div>
</template>

<script>
import HomeNav from '@/components/HomeNav'
import axios from 'axios'
export default {
  name: "Washingto",
  props:{
    newList:{
      type:Array,
      required: true
    }
  },
  components:{
    'my-HomeNav': HomeNav,
  },
  data() {
    return {
      activeName: "first",
      showIndex: 0,
      tuList:[],
      newsList: [],
      szfNewsList: []
    }
  },
  watch:{
    newList: async function () {
      this.newsList = [...this.newList]
      for(let i=0;i<this.newList[0].content.length;i++){
        if(this.newList[0].content[i].thumbnail&&this.tuList.length<4){
          this.tuList.push(
            {
              id:this.newList[0].content[i].id,
              img:this.newList[0].content[i].thumbnail,
              title:this.newList[0].content[i].title
            }
          )
        }
      }
      //await this.getSzfNews()
    }
  },
  methods: {
    toSzf () {
      window.open("https://www.sc.gov.cn/")
    },
    // 爬取省政府新闻
    async getSzfNews () {
      const resp = await axios.get('/static/szf')
      const htmlDom = $(resp.data)
      const news = htmlDom.find('#dash-table li a')
      const times = htmlDom.find('#dash-table li span')
      news.splice(0, 5).forEach((item, index) => {
        this.szfNewsList.push({
          title: item.innerText,
          url: `https://www.sc.gov.cn${item.pathname}`,
          check_time: times[index].innerText.replace('(', '').replace(')', '')
        })
      })
      this.newsList.unshift({
        name: '省政府信息',
        content: this.szfNewsList
      })
    },
    handleClick(tab, event) {
      // console.log(tab, event);
    },
    setIndex(index){
      this.showIndex=index
    },
    toList (id) {
      if(this.showIndex == 0) {
        this.$router.push(`/news/${id}`)
      }else
        window.open('https://www.sc.gov.cn/10462/c109616/comlist_15.shtml')
    },
    to (id) {
      this.$router.push(`/news/${id}`)
    },
    toDetail(item){
      if(this.showIndex == 0) {
        this.$router.push(`/content/${item.id}`)
      } else
        window.open(item.url)
    }
  },
}
</script>

<style scoped>
.container {
  /*width: 1290px;*/
  width: 100%;
  height: 500px;
  display: flex;
  /* align-items: center; */
  justify-content: space-between;
}
.dian{
  position: relative;
  top:5px;
  width: 20px;
  height: 20px;
}
.swipper{
  background-color: white;
  width: 50%;
  margin-bottom: 30px;
  max-height: 322px;
}

.swipper >>> .el-carousel__arrow {
  font-size: 24px;
}
.swipper >>> .el-carousel__button {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #fff;
  opacity: .48;
}
.swipper >>> .is-active .el-carousel__button {
  opacity: 1;
}
.swipper >>>  .el-carousel__indicators--horizontal{
  left: 85%;
}

.swipper {
  box-sizing: border-box;
  flex: 1;
  height: 80%;
  margin-right: 10px;
}
.desc {
  position: absolute;
  width: 100%;
  height: 40px;
  line-height: 40px;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
}
.desc p{
  position: relative;
  left: 10px;
  color: white;
  margin: 0;
  padding: 0;
  font-size: 15px;
}
a {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  width: 80%;
  color: #fff;
}
a:hover {
  text-decoration: underline;
  cursor: pointer;
}

.swipper-img {
  width: 100%;
  /*height: calc(550px*5/8);*/
  height: 500px;
}

.container >>> .el-tabs__active-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 0;
  background-color: #409EFF;
  z-index: 1;}

.container >>> .el-tabs__item {
  padding: 0 10px;
  height: 40px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  line-height: 40px;
  display: inline-block;
  list-style: none;
  font-size: 14px;
  /*font-weight: 500;*/
  color: #fff;
  position: relative;
  font-weight: bold;
}

.nes-wrapper{
  width: 40%;
  height: 500px;
  /*box-shadow: 1px 1px 4px #ccc;*/
  /*border: 1px solid #ccc;*/
  background-color: white;
  /* padding: 10px; */
  position: relative;
  overflow: hidden;
}

.nes-wrapper .img {
  cursor: pointer
}

.nes-header{
  border-bottom: 1px solid #ccc;
  display: flex;
  align-items: center;
  width: 100%;
  height: 44px;
  padding: 0 5px;
}
.header-item{
  display: flex;
  align-items: center;
  font-size: 20px;
  margin-right: 20px;
  height: 100%;
  font-weight: bold;
  color:#000;
}
.header-item:hover{
  cursor: pointer;
}
.header-item-active{
  /*border-bottom: 2px solid #2574c2;*/
  color: #2574c2;
}
.news-item-line:first-child:after{
  width: 20px;
  font-size: 13px;
  color: red;
}
.news-item-line{
  display: flex;
  justify-content: space-between;
  padding: 9px 5px;
  font-size: 16px;
  position: relative;
  /*width: 100%;*/
  color: #000;
}
.news-item-line span:first-child:hover{
  color: #2574c2;
  cursor: pointer;
  /*text-decoration: underline;*/
}
.news-item-line span:first-child{
  font-size: 17px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  /*word-break: break-all;*/
}
.nes-add{
  position: absolute;
  right: 10px;
  color: #999999;
}
.nes-add:hover{
  color: #2574c2;
  cursor: pointer;
}
.new_sss{
  color: #999999;
}
.new_sss:hover{
  color: #2574c2;
  font-size: 14px;
  cursor: pointer;
}


</style>



// WEBPACK FOOTER //
// src/components/Washingto.vue